// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type PersonSuggestionFragment = {
  fullName?: string | null;
  personUid?: string | null;
  primaryOrgName?: string | null;
  companyWorkerId?: string | null;
};

export type GetSuggestedPersonsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetSuggestedPersonsQuery = {
  suggest: { suggestions?: Array<PersonSuggestionFragment | {} | null> | null };
};

export const PersonSuggestionFragmentDoc = gql`
    fragment personSuggestion on PersonSuggestionModel {
  fullName
  personUid
  primaryOrgName
  companyWorkerId
}
    ` as unknown as DocumentNode<PersonSuggestionFragment, unknown>;
export const GetSuggestedPersonsDocument = gql`
    query getSuggestedPersons($search: String, $limit: Int) {
  suggest(limit: $limit, search: $search) {
    suggestions {
      ...personSuggestion
    }
  }
}
    ${PersonSuggestionFragmentDoc}` as unknown as DocumentNode<
  GetSuggestedPersonsQuery,
  GetSuggestedPersonsQueryVariables
>;
